import useCdcProps from '@/composables/useCdcProps'
import router from '@/router'

export default function () {
  const { xprops } = useCdcProps()

  const navigateToMBO = xprops?.handleNavigateToMBO
  const navigateToPage = xprops?.handleNavigateToPage
  const reloadPage = xprops?.handleReloadPage
  const navigateToMboHome = xprops?.handleNavigateToMboHome
  const navigateToMboModuleCatalog = xprops?.handleNavigateToMboModuleCatalog
  const navigateToMboThemeCatalog = xprops?.handleNavigateToMboThemeCatalog
  const navigateToModuleManagerUpdatesTab =
    xprops?.handleNavigateToModuleManagerUpdatesTab
  
  function navigateToMboProductPage(id: number, technicalName: string) {
    const route = router.resolve({
      name: 'module',
      params: {
        id: id,
      },
    })
  
    navigateToMboHome(
      {
        mbo_cdc_path: '/' + route.href,
      },
      true,
      technicalName,
    )
  }
  return {
    navigateToMBO,
    navigateToPage,
    reloadPage,
    navigateToMboHome,
    navigateToMboModuleCatalog,
    navigateToMboThemeCatalog,
    navigateToModuleManagerUpdatesTab,
    navigateToMboProductPage,
  }
}
